module.exports = __webpack_public_path__ + "img/gallery-04.77399bba.jpg";